import React from "react";

function PositionsIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="38"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <rect x="2" y="7" width="5" height="5" rx="1" />
      <rect x="2" y="15" width="5" height="5" rx="1" />
      <line x1="9" y1="9.5" x2="22" y2="9.5" />
      <line x1="9" y1="17.5" x2="22" y2="17.5" />
      <line x1="9" y1="8" x2="9" y2="11" />
      <line x1="9" y1="16" x2="9" y2="19" />
    </svg>
  );
}

export default PositionsIcon;
